import cn from '../utils/cn';

// Koob's wordmark (the logo pack's svg/wordmark): K, O, O and B, the B's
// lower half orange.
const LETTERS =
  'M0 0H22V30L46 0H74L43.6 38H0ZM0 42H43.6L74 80H46L22 50V80H0Z' +
  'M82 40A40 40 0 1 0 162 40A40 40 0 1 0 82 40ZM102 40A20 20 0 1 0 142 40A20 20 0 1 0 102 40Z' +
  'M170 40A40 40 0 1 0 250 40A40 40 0 1 0 170 40ZM190 40A20 20 0 1 0 230 40A20 20 0 1 0 190 40Z' +
  'M264 0H289A19 19 0 0 1 289 38H264Z';
const ACCENT = 'M264 42H297A19 19 0 0 1 297 80H264Z';

/** The Koob wordmark: navy letters, or white on navy with `reverse`. */
export default function KoobLogo({
  className,
  reverse = false,
}: {
  className?: string;
  reverse?: boolean;
}) {
  return (
    <svg
      viewBox="0 0 318 80"
      role="img"
      aria-label="Koob"
      className={className}
    >
      <path
        className={reverse ? 'fill-white' : 'fill-k-h'}
        fillRule="evenodd"
        d={LETTERS}
      />
      <path className="fill-k-orange" d={ACCENT} />
    </svg>
  );
}

/** The B alone (the pack's svg/icon glyph), for illustrations. */
export function KoobGlyph({
  className,
  top = 'fill-k-h',
}: {
  className?: string;
  /** Fill class of the top half; the bottom half stays orange. */
  top?: string;
}) {
  return (
    <svg viewBox="28 22 45 56" aria-hidden className={cn(className)}>
      <path className={top} d="M28 22H54A13 13 0 0 1 54 48H28Z" />
      <path className="fill-k-orange" d="M28 52H60A13 13 0 0 1 60 78H28Z" />
    </svg>
  );
}
